<template>
  <div></div>
</template>

<script>
import {statusApi,} from "../api/home/home.js";

export default {

  data() {
    return {};
  },
  created() {
    const url = window.location.href;
    const tokenStart = url.indexOf('token=') + 6; // 找到 'token=' 后的索引位置
    let token = '';
    if (tokenStart > 6) {
      const tokenEnd = url.indexOf('&', tokenStart); // 寻找 & 符号，表示参数的结束
      token = tokenEnd === -1 ? url.substring(tokenStart) : url.substring(tokenStart, tokenEnd);
    }
    localStorage.setItem('token', token);
    statusApi({token}).then((res) => {
      if (res.code == 1000) {
        const name = res.user.username
        const role = res.user.role
        localStorage.setItem('name', name);
        // 如果获取到了token，刷新页面前往指定页面
        if (role == 6) {
          this.$router.push('/Business_report');
        } else {
          this.$router.push('/');
        }
      } else {
        // 如果没有获取到token，前往其他指定页面
        window.location.href = 'https://www.vimiu3d.com/manage/login/login';
      }

    });

  },
  mounted() {
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/login/index.vue